<template>
  <div class="dark-theme-wrapper">
    <div class="container py-5">
      <h1 class="main-title text-center mb-5">ADMINISTRACE ZÁPASŮ</h1>

      <div class="admin-card mx-auto">
        <h2 class="section-title text-center mb-4">PŘIDAT NOVÝ ZÁPAS</h2>

        <form @submit.prevent="addMatch">
          <div class="row g-4 mb-4">
            <div class="col-md-6">
              <label class="form-label">ČÍSLO KOLA</label>
              <input
                type="number"
                v-model="roundNumber"
                min="1"
                class="form-control dark-input text-center font-bold"
                required
                placeholder="Např. 13"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label">DATUM A ČAS VÝKOPU</label>
              <input
                type="datetime-local"
                v-model="matchDate"
                class="form-control dark-input text-center"
                required
              />
            </div>
          </div>

          <hr class="separator my-5" />

          <div class="matchup-grid mb-5">
            <div class="team-select-box">
              <label class="form-label text-center w-100">DOMÁCÍ TÝM</label>
              <select
                v-model="homeTeam"
                class="form-select dark-input mb-3"
                required
              >
                <option :value="null" disabled>Vyberte tým</option>
                <option v-for="team in teams" :key="team.id" :value="team">
                  {{ team.name }}
                </option>
              </select>

              <div class="logo-preview">
                <img
                  v-if="homeTeam"
                  :src="homeTeam.logo"
                  alt="Home Logo"
                  class="preview-img fade-in"
                />
                <div v-else class="placeholder-circle">?</div>
              </div>
            </div>

            <div class="vs-center">
              <span class="vs-text">VS</span>
            </div>

            <div class="team-select-box">
              <label class="form-label text-center w-100">HOSTUJÍCÍ TÝM</label>
              <select
                v-model="awayTeam"
                class="form-select dark-input mb-3"
                required
              >
                <option :value="null" disabled>Vyberte tým</option>
                <option v-for="team in teams" :key="team.id" :value="team">
                  {{ team.name }}
                </option>
              </select>

              <div class="logo-preview">
                <img
                  v-if="awayTeam"
                  :src="awayTeam.logo"
                  alt="Away Logo"
                  class="preview-img fade-in"
                />
                <div v-else class="placeholder-circle">?</div>
              </div>
            </div>
          </div>

          <button type="submit" class="btn-red-glow w-100 mt-3">
            ULOŽIT ZÁPAS
          </button>
        </form>

        <transition name="fade">
          <div v-if="successMessage" class="alert-success-custom mt-4">
            {{ successMessage }}
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../firebase";
import {
  collection,
  getDocs,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";

export default {
  data() {
    return {
      roundNumber: "",
      homeTeam: null,
      awayTeam: null,
      matchDate: "",
      teams: [],
      successMessage: "",
    };
  },
  async mounted() {
    await this.fetchTeams();
  },
  methods: {
    async fetchTeams() {
      try {
        const teamsQuery = await getDocs(collection(db, "teams"));
        this.teams = teamsQuery.docs.map((doc) => ({
          id: doc.id,
          name: doc.data().name,
          logo: doc.data().logo,
        }));
      } catch (error) {
        console.error("Chyba při načítání týmů:", error);
      }
    },

    async addMatch() {
      try {
        if (!this.roundNumber || !this.homeTeam || !this.awayTeam) {
          alert("Vyplňte všechny údaje!");
          return;
        }

        await addDoc(collection(db, "matches"), {
          roundNumber: parseInt(this.roundNumber), // Převedeme na číslo pro jistotu
          homeTeam: this.homeTeam.name,
          awayTeam: this.awayTeam.name,
          homeLogo: this.homeTeam.logo,
          awayLogo: this.awayTeam.logo,
          matchDate: this.matchDate || new Date().toISOString(),
          homeScore: 0,
          awayScore: 0,
          evaluated: false,
          createdAt: serverTimestamp(),
        });

        // Reset
        this.homeTeam = null;
        this.awayTeam = null;
        // roundNumber a matchDate neresetuji úplně, protože admin často zadává více zápasů pro stejné kolo/datum
        this.successMessage = "✅ Zápas byl úspěšně vložen do databáze.";
        setTimeout(() => (this.successMessage = ""), 3000);
      } catch (error) {
        console.error("Chyba při přidávání zápasu:", error);
        alert("Chyba: " + error.message);
      }
    },
  },
};
</script>
